<mat-progress-spinner
  [diameter]="config.diameter"
  [mode]="'indeterminate'"
  [value]="50">
</mat-progress-spinner>

